export enum AdminTreatmentStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
